import * as UserSessionStorage from "../../utils/userSessionStorage";

import { createAction, handleActions } from "redux-actions";

import { createOmniPaginationObject } from "../../utils/helpers";

const actionScope = "ASSESSMENTSESSION_";

export const assessmentSessionRequestFailed = createAction(actionScope + "REQUEST_FAIL");

export const loadAssessmentODMRequest = createAction(actionScope + "LOAD_ASSESSMENT_ODM_REQUEST");
export const loadAssessmentODMSuccess = createAction(actionScope + "LOAD_ASSESSMENT_ODM_SUCCESS");

export const loadAssessmentTemplatesRequest = createAction(
  actionScope + "LOAD_ASSESSMENT_TEMPLATES_REQUEST"
);
export const loadAssessmentTemplatesSuccess = createAction(
  actionScope + "LOAD_ASSESSMENT__TEMPLATES_SUCCESS"
);

export const setAssessmentODMRequest = createAction(actionScope + "SET_ASSESSMENT_ODM_REQUEST");
export const setAssessmentODMSuccess = createAction(actionScope + "SET_ASSESSMENT_ODM_SUCCESS");

export const setAssessmentTemplateODMRequest = createAction(
  actionScope + "SET_ASSESSMENT_ODM_REQUEST"
);
export const setAssessmentTemplateODMSuccess = createAction(
  actionScope + "SET_ASSESSMENT_ODM_SUCCESS"
);

export const updateAssessmentRequest = createAction(actionScope + "UPDATE_ASSESSMENT_REQUEST");
export const updateAssessmentSuccess = createAction(actionScope + "UPDATE_ASSESSMENT_SUCCESS");

export const deleteAssessmentRequest = createAction(actionScope + "DELETE_ASSESSMENT_REQUEST");
export const deleteAssessmentSuccess = createAction(actionScope + "DELETE_ASSESSMENT_SUCCESS");

// selectors
export const assessmentODMSelector = state => state.assessmentSession.assessmentODM;
export const assessmentTemplateODMSelector = state => state.assessmentSession.assessmentTemplateODM;

//#region Assessment Paginiation

export const assessmentPaginationFocusSelector = state =>
  state.assessmentSession.assessmentPaginationFocus;
export const setAssessmentPaginationFocusRequest = createAction(
  actionScope + "SET_ASSESSMENT_PAGINATION_FOCUS_REQUEST"
);
export const setAssessmentPaginationFocusSuccess = createAction(
  actionScope + "SET_ASSESSMENT_PAGINATION_FOCUS_SUCCESS"
);

export const loadAssessmentsRequest = createAction(actionScope + "LOAD_ASSESSMENTS_REQUEST");
export const loadAssessmentsSuccess = createAction(actionScope + "LOAD_ASSESSMENTS_SUCCESS");

export const assessmentPagesSelector = state => state.assessmentSession.assessmentPages;
export const assessmentPaginationSelector = state => state.assessmentSession.assessmentPagination;

export const reflectUpdatedAssessmentODMRequest = createAction(
  actionScope + "REFLECT_UPDATED_ASSESSMENT_ODM_REQUEST"
);
export const reflectUpdatedAssessmentODMSuccess = createAction(
  actionScope + "REFLECT_UPDATED_ASSESSMENT_ODM_SUCCESS"
);
//#endregion

// initial state
const initialState = {
  //these members use the omnDataModel defined by the JSON in this project
  assessmentODM: null,
  assessmentTemplateODM: null,
  assessmentTemplates: null,

  //Assessment Pagination
  assessmentPaginationFocus: UserSessionStorage.tryRestoreLastAssessmentType(), //Used to drive the focues of athe assessment ODMs

  assessmentODMs: null, //all ODMs in the current page
  assessmentPages: {},
  assessmentPageLoading: false,
  assessmentPagination: createOmniPaginationObject(null, 10),
};

// reducers
export default handleActions(
  {
    [assessmentSessionRequestFailed]: state => state,
    [loadAssessmentsRequest]: (state, { payload }) => ({
      ...state,
      assessmentPageLoading: true,
    }),

    [loadAssessmentsSuccess]: (state, { payload }) => ({
      ...state,
      assessmentPages: payload.pages,
      assessmentODMs: payload.items,
      assessmentPagination: payload.pagination,
      assessmentPageLoading: false,
    }),

    [loadAssessmentODMRequest]: state => state,
    [loadAssessmentODMSuccess]: (state, { payload }) => ({
      ...state,
      assessmentODM: payload,
    }),

    [loadAssessmentTemplatesRequest]: state => state,
    [loadAssessmentTemplatesSuccess]: (state, { payload }) => ({
      ...state,
      assessmentTemplates: payload,
    }),

    [setAssessmentPaginationFocusRequest]: state => state,
    [setAssessmentPaginationFocusSuccess]: (state, { payload }) => ({
      ...state,
      assessmentPaginationFocus: payload,
    }),

    [setAssessmentODMRequest]: state => state,
    [setAssessmentODMSuccess]: (state, { payload }) => ({
      ...state,
      assessmentODM: payload,
    }),

    [setAssessmentTemplateODMRequest]: state => state,
    [setAssessmentTemplateODMSuccess]: (state, { payload }) => ({
      ...state,
      assessmentTemplateODM: payload,
    }),

    [updateAssessmentRequest]: state => state,
    [updateAssessmentSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [deleteAssessmentRequest]: state => state,
    [deleteAssessmentSuccess]: (state, { payload }) => ({
      ...state,
    }),
  },
  initialState
);
